export const PORTFOLIO_COLLECTION_DISPLAY_NAME = 'Registered';
export const SEQUENCE_COLLECTION_DISPLAY_NAME = 'Artifact';
